<template>
  <div>
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <v-row class="ma-4"><h2>Painel de gestão:</h2></v-row>
      <v-row>
        <!-- <v-col v-if="hadPermission(18,5)"> -->
        <v-col v-if="hadPermission(0,0)">
          <div style="height: 200px" class="item">
            <div
              @click="controller.requestPage(14)"
              class="d-flex flex-column align-center"
            >
              <v-icon size="60" color="primary">mdi-calendar-month</v-icon>
              <h2>Agendamento de OS</h2>
            </div>
          </div>
        </v-col>
        <v-col v-if="hadPermission(0,0)">
          <div style="height: 200px" class="item">
            <div
              @click="controller.requestPage(15)"
              class="d-flex flex-column align-center"
            >
              <v-icon size="60" color="primary">mdi-account-hard-hat-outline</v-icon>
              <h2>Técnicos</h2>
            </div>
          </div>
        </v-col>
        <v-col v-if="hadPermission(16,5)">
          <div style="height: 200px" class="item">
            <div
            @click="controller.requestPage(16)" 
            class="d-flex flex-column align-center">
              <v-icon size="60" color="primary"
                >mdi-clipboard-text-clock-outline</v-icon
              >
              <h2>Visitas</h2>
            </div>
          </div>
        </v-col>
        <!-- <v-col v-if="hadPermission(0,0)">
          <div style="height: 200px" class="item">
            <div class="d-flex flex-column align-center">
              <v-icon size="60" color="primary">mdi-tools</v-icon>
              <h2>Manutenções (em breve)</h2>
            </div>
          </div>
        </v-col> -->
      </v-row>
    </div>
    <div v-if="$vuetify.breakpoint.smAndDown" class="dash-container-mobile">
      <div
        class="item-mobile"
        @click="controller.requestPage(14)"
        v-if="hadPermission(0,0)"

      >
        <div class="d-flex flex-column align-center">
          <v-icon size="40" color="primary">mdi-calendar-month</v-icon>
          <h3>Agendamento de OS</h3>
        </div>
      </div>
      <div
        class="item-mobile"
        @click="controller.requestPage(15)"
        v-if="hadPermission(0,0)"
      >
        <div class="d-flex flex-column align-center">
          <v-icon size="40" color="primary">mdi-account-hard-hat-outline</v-icon>
          <h3>Técnicos</h3>
        </div>
      </div>
      <div
        class="item-mobile"
        @click="controller.requestPage(16)"
        v-if="hadPermission(16,5)"
      >
        <div class="d-flex flex-column align-center">
          <v-icon size="40" color="primary"
            >mdi-clipboard-text-clock-outline</v-icon
          >
          <h3>Visitas</h3>
        </div>
      </div>
      <!-- <div
        class="item-mobile"
        v-if="hadPermission(0,0)"
      >
        <div class="d-flex flex-column align-center">
          <v-icon size="40" color="primary">mdi-tools</v-icon>
          <h3>Manutenções (em breve)</h3>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { hadPermission } from "@/core/domain/model/permission";
import { dashboardServiceOrderPanelController } from "@/di/di";

export default {
  data: (context) => ({
    controller: dashboardServiceOrderPanelController(context),
  })
};
</script>

<style>
.dash-container-desktop {
  height: 89vh;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-gap: 40px;
}
.item:nth-child(1) {
  background-color: var(--v-secondary-base);
  border: 3px solid var(--v-primary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  grid-column: 1 / 4;
  grid-row: 1 / 2;
}
.item:nth-child(1):hover {
  box-shadow: 0 0 12px var(--v-primary-base);
}
.item:nth-child(2) {
  background-color: var(--v-secondary-base);
  border: 3px solid var(--v-primary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  grid-column: 2 / 4;
  grid-row: 1 / 2;
}
.item:nth-child(2):hover {
  box-shadow: 0 0 12px var(--v-primary-base);
}
.item:nth-child(3) {
  background-color: var(--v-secondary-base);
  border: 3px solid var(--v-primary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  grid-column: 3 / 4;
  grid-row: 1 / 2;
}
.item:nth-child(3):hover {
  box-shadow: 0 0 12px var(--v-primary-base);
}
.item:nth-child(4) {
  background-color: var(--v-secondary-base);
  border: 3px solid var(--v-primary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  grid-column: 4 / 4;
  grid-row: 1 / 2;
}
.item:nth-child(4):hover {
  box-shadow: 0 0 12px var(--v-primary-base);
}

.dash-container-mobile {
  height: 89vh;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(6, 1fr);
  grid-gap: 16px;
}
.item-mobile:nth-child(1) {
  background-color: var(--v-secondary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  min-height: 120px;
  padding: 10px;
}
.item-mobile:nth-child(2) {
  background-color: var(--v-secondary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  grid-column: 2 / 2;
  grid-row: 1 / 2;
  min-height: 120px;
}
.item-mobile:nth-child(3) {
  background-color: var(--v-secondary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  grid-column: 1 / 2;
  grid-row: 2 / 2;
  min-height: 120px;
}
.item-mobile:nth-child(4) {
  background-color: var(--v-secondary-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  grid-column: 2 / 2;
  grid-row: 2 / 2;
  min-height: 120px;
}
</style>
